module.exports = __webpack_public_path__ + "img/tour-11.41e047a9.png";